<button title="Close" class="mat-close-btn" mat-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<h1 mat-dialog-title>{{title}}</h1>
<!-- <div mat-dialog-content>{{message}}</div> -->
<p [innerHtml]="message"></p>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</div>
